import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FallbackBlock = () => {
    return (
        <div className="animate-out fade-out-50 mt-16 flex h-screen items-center justify-center rounded-3xl bg-white sm:my-4 sm:ml-20 sm:rounded-l-3xl">
            <FontAwesomeIcon icon={faSpinnerThird} className="text-primary-700 animate-spin text-4xl" />
        </div>
    );
};

export { FallbackBlock };
